import { Product } from "interfaces";
import { useAuth } from "contexts/auth/auth.context";
import dynamic from "next/dynamic";

const ProductCardCounter = dynamic(
  () => import("components/productCardCounter/productCardCounter"),
);

const ProtectedProductCardCounter = dynamic(
  () => import("components/productCardCounter/protectedProductCardCounter"),
);

type Props = {
  data: Product;
};

export default function ProductCardCounterContainer({ data }: Props) {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <ProtectedProductCardCounter data={data} />;
  }

  return <ProductCardCounter data={data} />;
}
